$('.stars > .star').click(function () {
    solidStars($(this))
    $(this).siblings('.active').removeClass('active');
    $(this).addClass('active').closest('.form-group').find('input').val($(this).data('star'))
}).mouseover(function () {
    solidStars($(this))
}).mouseleave(function () {
    let active = $(this).parent().find('.star.active');
    active.length ? solidStars(active) : $(this).parent().find('.star').addClass('far').removeClass('fas');
})

function solidStars(star) {
    star.addClass('fas').removeClass('far').prevAll().addClass('fas').removeClass('far');
    star.nextAll().addClass('far').removeClass('fas');
}
